import { render } from "./ProfileDropdown.vue?vue&type=template&id=31ecab27"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"

import "./ProfileDropdown.vue?vue&type=style&index=0&id=31ecab27&lang=scss"
script.render = render

export default script